import { HubsTrackingAttr } from 'signup-constants/HubsTrackingAttr';
import { getQueryParam } from '../routing/getQueryParam';
import { getRouteParams } from '../routing/getRouteParams';
import { SignupEmbedder } from 'signup-embedder';
export const getExternalTrackingParam = () => {
  const {
    queryParams
  } = getRouteParams();
  const externalExperimentParameter = queryParams['external-experiment-parameter'];
  return externalExperimentParameter;
};
export const getIsComingFromEmailSignatureGenerator = () => {
  const hubsSignupCtaParam = getQueryParam(HubsTrackingAttr.SignupCta);
  const hasHubsSignupCtaForEsg = hubsSignupCtaParam === 'esg-copy-modal';
  const isInstanceOfSignupEmbedder = SignupEmbedder.isActive();
  return hasHubsSignupCtaForEsg && isInstanceOfSignupEmbedder;
};